import { useNavigate } from 'react-router-dom';
import Button from '../../../components/button/Button';
import HeaderBasicLayout from '../../../components/header/headerBasicLayout/HeaderBasicLayout';
import { useBrandContext } from '../../../context/BrandContext';

import { useCallback, useEffect, useState } from 'react';
import angle from '../../../assets/angle.svg';
import { useAuth } from '../../../context/AuthContext';
import api from '../../../axios/axiosConfig';
import SwipeToRefresh from '../../../components/SwipeToRefresh/SwipeToRefresh';
import './styles.css';
import { ReactComponent as LoaderSecondary } from '../../../assets/SpinnerBlack.svg';
import { useHeaderContext } from '../../../context/HeaderContext';
import { triggerGlobalVehiclesRefresh, useVehiclesRefresh, setGlobalVehiclesRefresh } from '../../../hooks/useVehiclesRefresh';

const VehicleList = () => {
  const navigate = useNavigate();
  const brandContext = useBrandContext();
  const authContext = useAuth();
  const { setHeaderConfig } = useHeaderContext();
  const vehiclesRefresh = useVehiclesRefresh();
  const [vehicles, setVehicles] = useState<any[]>(() => authContext.user?.vehicles || []);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Registrar callback para atualização global
  useEffect(() => {
    setGlobalVehiclesRefresh(vehiclesRefresh);
  }, [vehiclesRefresh]);

  // Atualizar veículos quando contexto mudar
  useEffect(() => {
    if (authContext.user?.vehicles) {
      setVehicles(authContext.user.vehicles);
    }
  }, [authContext.user?.vehicles]);

  const getVehicles = useCallback(async (): Promise<any> => {
    try {
      const response = await api.get(`/UserVehicles`);
      return response.data;
    } catch (error) {
      console.error('Error fetching vehicles:', error);
      return [];
    }
  }, [authContext]);

  const loadVehicles = async () => {
    try {
      setIsLoading(true);
      const vehicles = await getVehicles();
      setVehicles(vehicles);
    } catch (error: any) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  };

  // Recarregar veículos quando há refresh (via add/edit/delete ou pull-to-refresh)
  useEffect(() => {
    if (vehiclesRefresh.refreshTrigger > 0) {
      loadVehicles();
    }
  }, [vehiclesRefresh.refreshTrigger, getVehicles]);

  useEffect(() => {
    setHeaderConfig({
      headerText: 'Veículos',
    });
    return () => setHeaderConfig({});
  }, [setHeaderConfig]);

  return (
    <div className='vehicles'>
      <div className='vehicles__header'>
        <h3 className='vehicles__title'>Veículos cadastrados</h3>
      </div>
      {isLoading ? (
        <div style={{ paddingTop: 20 }}>
          <LoaderSecondary />
        </div>
      ) : (
        <>
          <SwipeToRefresh onSwipeDown={loadVehicles}>
            {vehicles?.length === 0 ? (
              <p className='vehicles__message'>Não há veículos cadastrados</p>
            ) : (
              <div className='vehicles__list'>
                {vehicles?.map((vehicle: any, index: any) => (
                  <div
                    key={index}
                    className='vehicles__list-item'
                    onClick={() =>
                      navigate(
                        `/${brandContext.brandName}/vehicle-detail/${vehicle.uvId}`
                      )
                    }
                  >
                    <span className='vehicles__list-name'>
                      {vehicle.uvName}
                    </span>
                    <button className='vehicles__list-edit-button'>
                      <img src={angle} alt='right-icon' />
                    </button>
                  </div>
                ))}
              </div>
            )}
            <Button
              className='btn-outline'
              type='button'
              children='Novo veículo'
              onClick={() => navigate(`/${brandContext.brandName}/vehicles`)}
            />
          </SwipeToRefresh>
        </>
      )}
    </div>
  );
};

export default VehicleList;
